import { useTranslate } from "@tolgee/react";
import { useAtomValue, useSetAtom } from "jotai";
import DarkIcon from "#/assets/icons/nav/dark.svg?react";
import LightIcon from "#/assets/icons/nav/light.svg?react";
import { Button } from "#/components/ui/button";
import { cycleThemeModeAtom, themeModeAtom } from "../stores/theme-store";

export default function ThemeToggle() {
	const { t } = useTranslate();
	const mode = useAtomValue(themeModeAtom);
	const cycleMode = useSetAtom(cycleThemeModeAtom);

	const label = t("theme.mode-label", { mode });

	return (
		<Button
			variant="ghost"
			size="icon-sm"
			onClick={cycleMode}
			aria-label={label}
			title={label}
			className="w-10 text-foreground dark:text-foreground hover:text-foreground"
		>
			{mode === "dark" ? (
				<DarkIcon className="h-4 w-4" />
			) : (
				<LightIcon className="h-4 w-4" />
			)}
		</Button>
	);
}
